import React, {Component} from 'react';
 

// Layout
import Header from "../layout/header2";
import Footer from "../layout/footer";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";
import servicesPic1 from "../../images/services/pic5.jpg";
 
class ServiceC extends Component{
	
	render(){
		return (
			<>
				
				<Header />
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Equipo Calificado</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><a href="index.html"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Inicio</a></li>
											<li className="breadcrumb-item active" aria-current="page">Profesionales Calificados</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<section className="section-area section-special">
						<div className="container">
							<div className="row">
								<div className="col-lg-12 col-lx-10 mb-30">
									<div className="ttr-media mb-30 justify-content-md-center">
										<img src={servicesPic1} className="rounded mx-auto d-block" alt=""/>
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h2 className="title mb-15  text-center">GASTRO-CIRUGIA AGUASCALIENTES</h2>
 
											<p className="mb-30">Somos una empresa integrada por profesionales altamente reconocidos  a nivel nacional y certificados por  los consejos respectivos con amplia experiencia de más de 25 años de trayectoria profesional la cual ponemos a su disposición. Contamos con las instalaciones de la más alta calidad para la atención de cualquier tipo de padecimiento relacionado a nuestra área profesional (HOSPITALES MAC, STARMEDICA, BIOMATERNA, LABORATORIO CLINICO CMQ, LOS BOSQUES, ENTRE OTROS).</p>

											<p className="mb-30">Proponemos a ustedes otorgar nuestros servicios de evaluación inicial, estudios y tratamientos médicos y quirúrgicos  necesarios, mismos que se adecuaran en cada caso particular.</p>

											<p className="mb-30">En caso de que el paciente cuente con seguro de gastos médicos mayores no se cobrara la consulta de evaluación inicial y aseguramos adaptarnos a los tabuladores registrados en sus seguros en caso de requerir tratamiento quirúrgico a fin de omitir en lo posible el pago de deducible por honorarios médicos</p>
											<p className="mb-30">Pueden contactarnos por:</p>
	
											<p className="mb-30">Tel. 449 266 94 87 Ó 449 4370 550 Ó 449 164 7579</p>
											<div className="col-xl-9 col-lg-9 col-md-9">
												<div className="widget widget_form">
												<p className="mb-30">E-mail: dr.alvarezdelcastillo@gmail.com</p>
												<li className="btn-area"><a target="_blank" rel="noreferrer"  href="https://agsmedico.com/cirugia-general/alvarezdelcastillo" className="btn btn-primary shadow">AGENDAR CITA<i className="btn-icon-bx fas fa-chevron-right"></i></a></li>
												</div>
											</div>

 
										</div>
 
									</div>
 
								</div>
	 
							</div>
						</div>
					</section>
					
				</div>
				
				<Footer />
				
			</>
		);
	}
}

export default ServiceC;